<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="background text app-content-container">
  @if (!hideTopbar) {
    <app-topbar
      [title]="topbarText"
      [topbarView]="TopbarView.BLUEPRINT_HOME"
      [imageFilePath]="topbarImage"
      (urlNavigate)="goToUrl($event)"
    ></app-topbar>
  }

  @if (selectedMselId) {
    <app-scenario-event-list
      [loggedInUserId]="loggedInUserId"
      [userTheme]="userTheme$ | async"
      [isStarterMsel]="true"
    ></app-scenario-event-list>
  }
</div>
